import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=428cccc3&"
import script from "./DataViewer.vue?vue&type=script&lang=ts&"
export * from "./DataViewer.vue?vue&type=script&lang=ts&"
import style0 from "./DataViewer.vue?vue&type=style&index=0&id=428cccc3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports